import { Type } from '@sinclair/typebox';
export const ConstraintCollectionResponseSchema = Type.Object({
    id: Type.Number(),
    versionId: Type.Number(),
    name: Type.String(),
});
export const CreateConstraintCollectionSchema = Type.Omit(ConstraintCollectionResponseSchema, ['id']);
export const UpdateConstraintCollectionSchema = Type.Partial(Type.Omit(CreateConstraintCollectionSchema, ['versionId']));
//# sourceMappingURL=constraint-collections.js.map